
<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100vh">
        <div class="container">

         <div class="form-group" style="margin-top: 30px">
            <router-link to="/role/list" class="btn btn-default">{{ $t('Back') }}</router-link>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">{{ $t('Edit') }} </div>
            <div class="panel-body">
                <form v-on:submit.prevent="saveForm()">





                    <!-- <ul v-if="errors && errors.length" class="container ">
                        <li v-for="error of errors[0]" class="text-danger" >

                            <ul >
                                <li v-for="error_message of error" class="text-danger" >
                                    {{error_message}}
                                </li>
                            </ul>

                            <hr>


                        </li>
                    </ul> -->


                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('role') }}</label>
                                <input type="text" v-model="item.name" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>

                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <button class="btn btn-success">{{ $t('Edit') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </div>
</template>

<script>


    const auth = {
        headers: {Authorization:'bearer ' + localStorage.getItem('token')}
    };


    export default {

        mounted() {
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get('/admin-api/v1/role/change-user-role/' + id , auth)
                .then(function (resp) {
                    app.item = resp.data.data;
                    console.log(resp)
                })
                .catch(function (e) {
                     for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }
                });



//             axios
//                 .get('/api/productCategories', auth)
//                 .then(function (resp) {
//                     app.product_categories = resp.data.data;
//                     //    this.product_categories = response.data.data;
//                 })

//                 .catch(function () {

                    
//                     alert("بارگذاری آیتم امکان پذیر نیست");
// //                    console.log('a: ' + auth)
//                 });







        },
        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                itemId: null,
                item: {
                    parent_id: '',
                    service_categories_id: '1',
                    title: '',
                    image: null,
                    description: '',
                    initial_number: '',
                    price: '',
                    tax: 0,
                    min_time: '',
                    max_time: ''


                },

                errors: [],
                service_categories: []

            }
        },


        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                axios.patch('/api/orders/' + app.itemId, newItem , app.auth)
                    .then(function (resp) {
                        app.$router.replace('/products');
                    })
                    .catch(function (resp) {
                        console.log(resp);
                        this.errors.push(resp.response.data.messages);
                            for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,

                                    closeOnClick: true,
                                    pauseOnHover: true
                                });
                             }
                    });
            }
        }
    }
</script>
